const supportAccountIdsStr: string = import.meta.env.VITE_SUPPORT_ACCOUNTS
export const supportAccountIds = new Set(supportAccountIdsStr?.split(',') || [])

const superUserAccountIdsStr: string = import.meta.env.VITE_SUPER_USER_ACCOUNTS
export const superUserAccountIds = new Set(
  superUserAccountIdsStr?.split(',') || [],
)
